module.exports = __webpack_public_path__ + "static/home-slider4-af64231431bd5d9e6f56cd7c76d05736.jpeg";